import { render, staticRenderFns } from "./EditCamposSistema.vue?vue&type=template&id=43508623&scoped=true"
import script from "./EditCamposSistema.vue?vue&type=script&lang=js"
export * from "./EditCamposSistema.vue?vue&type=script&lang=js"
import style0 from "./EditCamposSistema.vue?vue&type=style&index=0&id=43508623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43508623",
  null
  
)

export default component.exports